import styled from 'styled-components';
import { Typography } from '@mui/material';

const FilePreviewContainer = styled.div`
  display: flex;
  width: auto;
  height: 100%;
  max-height: 100%;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

const FileIconContainer = styled.div`
  cursor: pointer;
`;

const FileTitle = styled(Typography)`
  margin-top: 10px;
  font-size: 12px;
  font-weight: 500;
  width: 70%;
  text-align: center;
`;

export {
  FilePreviewContainer,
  FileIconContainer,
  FileTitle,
};
